module.exports = __webpack_public_path__ + "img/mirt-black-friday.d861737c.png";